const script = `\
import BloctoIdo from 0xIDOADDRESS

access(all) fun main (address: Address): Bool {
  return getAccount(address).getCapability(BloctoIdo.BloctoIdoUserPublicPath).borrow<&{BloctoIdo.UserPublic}>() != nil
}
`

export default script
